// Lib
import React, { ReactElement } from 'react';

// Hooks
import useCardTiptapEditorExtensions from '../../card/tiptap/useCardTiptapEditorExtensions';
import useClientElementTiptapEditor from '../../../components/tiptapEditor/useClientElementTiptapEditor';

// Types
import { EditorContent } from '@tiptap/react';
import { TiptapContent } from '../../../../common/tiptap/tiptapTypes';

// Styles
import './DocumentDetailViewTiptapEditor.scss';
import { useTranslator } from "../../../components/i18n/useTranslator";

interface DocumentDetailViewTiptapEditorProps {
    textContent: TiptapContent;
    editorId: string;
    editorKey: string;
}

const DocumentDetailViewTiptapEditor = (props: DocumentDetailViewTiptapEditorProps): ReactElement => {
    const { textContent, editorId, editorKey } = props;

    const translate = useTranslator('elements', 'elementTypes.document');

    const extensions = useCardTiptapEditorExtensions({ universalCardConversion: false , translate });

    const { editor } = useClientElementTiptapEditor({
        persistedContent: textContent,
        extensions,

        editorId,
        editorKey,

        isEditable: false,
        isEditing: false,
        isSingleSelected: false,
    });

    return (
        <div className="DocumentDetailViewTiptapEditorContainer">
            <EditorContent className="DocumentDetailViewTiptapEditor" dir="auto" editor={editor} />
        </div>
    );
};

export default DocumentDetailViewTiptapEditor;
